import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { AddButtonSuccessMessage } from "../../../../components/modules/Upsell/components/AddButtonSuccessMessage.js";
const AddButtonSuccessMessageContainer = () => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      addedToCart: getLabel("cart.notification.addedToCart")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(AddButtonSuccessMessage, { caption: labels.addedToCart });
};
export {
  AddButtonSuccessMessageContainer
};
//# sourceMappingURL=AddButtonSuccessMessageContainer.js.map
